import { Localized } from "@fluent/react/compat";
import React, { FunctionComponent } from "react";

import { QUEUE_NAME } from "coral-framework/helpers";
import { Option, SelectField } from "coral-ui/components/v2";

interface Props {
  filterType: string;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  queueName: QUEUE_NAME | undefined;
}

const QueueFilter: FunctionComponent<Props> = ({
  filterType,
  onChange,
  queueName,
}) => {
  return (
    <div>
      <SelectField value={filterType} onChange={onChange}>
        <Localized id="queue-filterMenu-none">
          <Option value="none">None</Option>
        </Localized>
        {queueName === "approved" && (
          <>
            <Localized id="queue-filterMenu-featured">
              <Option value="featured">Featured</Option>
            </Localized>
            <Localized id="queue-filterMenu-qa">
              <Option value="qa">Q&A</Option>
            </Localized>
          </>
        )}
        <Localized id="queue-filterMenu-withImages">
          <Option value="withImages">With Images</Option>
        </Localized>
      </SelectField>
    </div>
  );
};

export default QueueFilter;
